//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import ComponentGroupDelete from './delete';
import ComponentGroupEdit from './edit';
import ComponentGroup from './list';

export const FilterComponentGroup = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "component_group") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterComponentGroup.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/component_group" exact component={ComponentGroup} isPrivate/>
      <Route path="/premixlabel/component_group/edit/:id" exact component={ComponentGroupEdit} isPrivate/>
      <Route path="/premixlabel/component_group/add" exact component={ComponentGroupEdit} isPrivate/>
      <Route path="/premixlabel/component_group/delete/:id" exact component={ComponentGroupDelete} isPrivate/>
    </FilterComponentGroup.Provider>
  )
}  